import {
    ActionComponentDefinition,
    ComponentWithOptions,
    InputComponent,
    LabeledComponentDefinition,
    ValueComponentDefinition,
} from "components/components/Component";
import { setComponentWidths } from "components/components/ComponentWidthSetUtil";
import { InputBaseComponent } from "components/components/InputBaseComponent";
import { ComponentActionHelper } from "components/events/componentActionHelper";
import { fireDataChangedEvent } from "components/form/dataChangedEventDetail";
import { isOption, OptionHolder, SearcherParameter } from "components/input/select/options";
import $ from "jquery";
import { LabelElement } from "components/components/label/labelElement";
import { ItemComposedFinderModalDefinition } from "components/input/searcherWithCode/baseItemFinderElement";
import { ComposedSearcherInput, SearcherWithComposedCodeValue } from "components/input/searcherWithCode/searcherWithComposedCode/searcherWithComposedCode";
import "components/input/searcherWithCode/searcherWithComposedCode/searcherWithComposedCode.scss";
import { mergeOptions } from "components/input/searcherWithCode/OptionsMergeUtil";
import { initMultiSearcherWithComposedCodeElementeWebComponent, MultiSearcherWithComposedCodeElement } from "./components/multiSearcherWithComposedCodeElement";
import template from "./multiSearcherWithComposedCode.hbs";

initMultiSearcherWithComposedCodeElementeWebComponent();

export class MultiSearcherWithComposedCode
    extends InputBaseComponent<MultiSearcherWithComposedCodeDefinition>
    implements InputComponent, ComponentWithOptions {
    public componentType = "multisearcherWithComposedCode";
    private queryParameters: SearcherParameter[];
    private element: MultiSearcherWithComposedCodeElement;

    constructor(schema: MultiSearcherWithComposedCodeDefinition) {
        super(schema);

        setComponentWidths(this.definition);
        this.fillInputs(this.definition);

        this.definition.finder = {
            ...this.definition.finder,
            codeAttributes: this.definition.finder.codeAttributes ?? this.definition.finder.table?.idColumns,
            detailAttribute: this.definition.finder.detailAttribute ?? "detail",
            outputParameterMappings: null,
        };
    }

    private fillInputs(definition: MultiSearcherWithComposedCodeDefinition) {
        if (definition.inputs == null && definition.finder != null) {
            definition.inputs = [];
            if (definition.finder.codeAttributes == null) {
                definition.finder.codeAttributes = definition.finder.table.idColumns;
            }
            for (const codeAtrribute of definition.finder.codeAttributes) {
                definition.inputs.push({ id: codeAtrribute });
            }
        }
    }

    public render(): Element {
        let jqueryView = $(template(this.definition));
        this.view = jqueryView[0];
        ComponentActionHelper.register(this);
        this.element = this.view.querySelector("s6-multi-searcher-with-composed-code");
        this.element.finder = this.definition.finder;
        this.element.inputs = this.definition.inputs;
        this.element.addEventListener("change", (evt) => fireDataChangedEvent(this, this.view, this.getValue()));
        return this.view;
    }

    public getValue(): SearcherWithComposedCodeValue[] {
        if (this.element.data == null || this.element.data.length === 0) {
            return null;
        }
        return this.element.data;
    }

    public value(v: any) {
        this.element.data = v;
    }

    public setReadOnly(ro: boolean) {
        this.element.readOnly = ro;
    }


    public setRequired(required: boolean) {
        const label = (this.view.querySelector("s6-input-label") as LabelElement);
        if (label != null) {
            label.required = required;
        }
    }

    public setValidationStatus(valid: boolean, message?: string | string[] | any) {
        this.element.valid = valid;
        this.element.validationMessage = message || null;
    }

    public addOptions(options: OptionHolder): void {
        MultiSearcherWithComposedCode.cleanupOptions(options);
        this.queryParameters = this.queryParameters ?? [];
        let mergeResults = mergeOptions(this.queryParameters, options);
        this.queryParameters = mergeResults.queryParameters;
        this.element.queryParameters = this.queryParameters;
    }

    public static cleanupOptions(options: OptionHolder) {
        if (Array.isArray(options)) {
            for (const option of options) {
                if (isOption(option)) {
                    if (option.value === "") {
                        option.value = undefined;
                    }
                }
            }
        }
    }

    public setOptions = this.addOptions;
}

export interface MultiSearcherWithComposedCodeDefinition extends LabeledComponentDefinition,
    ValueComponentDefinition,
    ActionComponentDefinition {
    inputWidth?: number;
    inputs: ComposedSearcherInput[];
    finder?: ItemComposedFinderModalDefinition;
}
